<template>
  <v-dialog
    v-model="dialog"
    width="500px">
    <div class="dialog-container">
      <div class="dialog-header flex-sb">
        <span>Upload Supporting Document </span>
        <span
          class="el-icon-close icon"
          @click="handleCancel"></span>
      </div>
      <div class="dialog-body">
        <div class="form-item">
          <el-form
            ref="form"
            :model="formData"
            :rules="rules">
            <div class="form-item">
              <span>File Name</span>
              <el-form-item
                :rules="rules.input"
                prop="name">
                <v-input
                  v-model="formData.name"
                />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Document</span>
              <el-form-item
                :rules="rules.upload"
                prop="id">
                <v-upload
                  ref="upload_item"
                  :fileData="{
                    thumb_url: formData.url,
                    url: formData.url,
                    client_name:formData.client_name
                  }"
                  card
                  widthFull
                  @delete="handleDel"
                  @uploadSuccess='uploadSuccess'></v-upload>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="flex-sb">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="handleUpload">Upload</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {uploadEnquiryDoc,} from '@/api/enquiry'
export default {
  name: 'UploadClaimDocDialog',
  mixins: [MixinOptions,MixinRules],
  props:{
    order_id:{
      type: Number,
      default: 0
    },
    value:{
      type:Boolean,
      default: false
    },
    form:{
      type:Object,
      default: ()=>({})
    }
  },
  data () {
    return {
      dialog: false,
      formData:{
        name:'',
        id: '',
        client_name:'',
        url:'',
        upload_date:''
      },
    }
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        this.dialog = val
        if(val){
          this.formData = {...this.formData,...val}
          this.$nextTick(()=>{
            this.$refs.form.clearValidate()
          })
        }
      }
    },
    form:{
      immediate:true,
      handler(val){
        this.formData = {...this.formData,...val}
      }
    }
  },
  methods: {
    handleCancel(){
      this.formData  = {
        name:'',
        id:'',
        url:'',
        client_name:'',
        upload_date:''
      }
      this.dialog  = false
      this.$refs.form.clearValidate()
      this.$emit('input',false)

    },
    uploadSuccess(val){
      this.formData.id = val.data.id
      this.formData.client_name = val.data.client_name
      this.formData.url = val.data.url
      this.formData.upload_date = val.data.upload_date
      this.formData = {
        ...this.formData,
        file:val.data
      }
    },
    handleDel(){
      this.formData.id =''
      this.formData.client_name = ''
      this.formData.url =''
      this.formData.upload_date =''
    },
    handleUpload(){
      this.$refs['form'].validate(val => {
        if(val){
          this.$emit('upload',this.formData)
          setTimeout(()=>{
            this.formData  = {
              name:'',
              id:'',
              url:'',
              client_name:'',
              upload_date:''
            }
            this.$refs.form.clearValidate()
          },200)
          this.dialog  = false
          this.$emit('input',false)
        }
      })
    },
    network(){
      return {
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.dialog-container{
  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #1B1F23;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
    }
    .icon{
      cursor: pointer;
    }
  }
  .dialog-body{
    padding: 20px 15px;
    .text{
      padding-bottom: 0;
    }
    /deep/textarea{
      font-family: Arial;
    }
  }
  .dialog-footer{
    padding: 0 15px 15px 15px;
  }
}
</style>
